import { useCallback } from "react";
import { useGenerateConsolidatedReport } from "../services/reportService";

/** Generates the Excel-only consolidated report for all eligible buildings. */
export function useConsolidatedReportHandler() {
  const generateExcel = useGenerateConsolidatedReport();

  return useCallback(
    async (startDate: string, endDate: string): Promise<Blob | null> =>
      generateExcel.mutateAsync({ start_date: startDate, end_date: endDate }),
    [generateExcel],
  );
}